<div class="controls-container">
    <div class="controls-header">Context Menu</div>

    <pm-button ButtonClass="button-flat-transparent layout-flex" [contextMenu]="contextMenu"><pm-icon-bars [style.padding-right.px]="5"></pm-icon-bars> Context Menu</pm-button>
    <pm-context-menu #contextMenu>
        <pm-context-menu-header>Context Menu</pm-context-menu-header>
        <pm-context-menu-item (click)="ClickExample()">Item 1</pm-context-menu-item>
        <pm-context-menu-item>Item 2</pm-context-menu-item>
        <pm-context-menu-divider></pm-context-menu-divider>
        <pm-context-menu-item>Item 3</pm-context-menu-item>
        <pm-context-menu-item IsDisabled="true">Item 4 Disabled</pm-context-menu-item>
    </pm-context-menu>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/context-menu/context-menu.html